import { a } from "../../../chunk-OA3DH5LS-40f95340.js";
const t = a("DatePicker").parts(
  "root",
  "calendar",
  "days",
  "day",
  "weekDays",
  "weekDay",
  "header",
  "input",
  "inputIcon",
  "range"
);
export {
  t as DatePickerAnatomy
};
//# sourceMappingURL=DatePicker.anatomy.es.js.map
